import React, { useEffect, useState } from "react";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../../services/firebase";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TopBar from "../TopBar/TopBar";
import './Signin.scss';
import { ppiApiAxios } from "../../services/api";

const Signin: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // This effect handles redirection if a user is already logged in
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        const redirectTo = new URLSearchParams(location.search).get("redirectTo") || "/";
        navigate(redirectTo, { replace: true });
      }
    });
    return unsubscribe;
  }, [navigate, location.search]);

  const [email, setEmailState] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  const handleSignin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null); // Clear previous errors
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const token = await userCredential.user?.getIdToken();
      await ppiApiAxios.post("/signin", { id_token: token });

      // The onAuthStateChanged listener in UserContext will handle the redirect and state update.
      // No need to manually set email or navigate here.

    } catch (error: any) {
      if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
        setError("Invalid email or password.");
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
      console.error("Signin Error:", error);
    }
  };

  const handleGoogleSignIn = async () => {
    setError(null);
    try {
      const userCredential = await signInWithPopup(auth, googleProvider);
      const token = await userCredential.user.getIdToken();
      await ppiApiAxios.post("/auth", { token: token });

    } catch (error: any) {
      console.error('Error signing in with Google:', error);
      setError(`Error during Google sign-in: ${error.message}`);
    }
  };

  return (
    <div className="page-container">
      <TopBar className="title" title="Sign In" />
      <div className="signin-container">
        <form className="form-container" onSubmit={handleSignin}>
          <h2>SIGN IN</h2>
          <div>
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmailState(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <button type="submit">Sign In</button>
          <button type="button" onClick={handleGoogleSignIn} className="google-signin-button">
            Sign In with Google
          </button>
          <div className="divider">
            <span>OR</span>
          </div>

          <div className="social-icons">
            {/* Social login options */}
          </div>
          <div className="signup-link"

            style={{ display: 'block', margin: '0 auto' }}
          >
            <Link to="/forgot-password">Forgot password?</Link>
          </div>
          <div className="signup-link">
            Need an Account? <Link to="/signup">SIGN UP FOR PACER</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Signin;
